import React from 'react'
import { JackInTheBox } from "react-awesome-reveal";
import sImg1 from '../../images/story/embarcadero.png'
import sImg2 from '../../images/story/5.jpg'
import sImg3 from '../../images/story/1.webp'

import flowerShape from '../../images/story/flower.svg'
import flowerShape2 from '../../images/story/flower-2.svg'
import ring from '../../images/story/ring.svg'

import shape1 from '../../images/story/flower-shape1.svg'
import shape2 from '../../images/story/flower-shape2.svg'
import shape3 from '../../images/story/flower-shape3.svg'
import shape4 from '../../images/story/flower-shape4.svg'
import SectionTitle from '../SectionTitle'




const Storys = [
    {
        sImg: sImg1,
        sImg2: sImg3,
        flower: flowerShape,
        title: '¿Cómo llegar?',
        description: `
            <p>
                El punto principal de encuentro es en 
                <strong>Hermenegildo Galeana 260, Barrio Xaltocan, Xochimilco, CDMX</strong>, 
                a una cuadra del <strong>Embarcadero Nuevo Nativitas</strong> 
                (verifica que sea <em>Nuevo Nativitas</em>).
            </p>
            <h3>Traslados en trajinera</h3>
            <p>
                Desde este punto (estacionamiento), las trajineras operarán de 
                <strong>16:00 a 17:40 horas</strong>, con salidas continuas en grupos de 
                <strong>20 personas</strong>. Cada recorrido dura aproximadamente 
                <strong>15–20 minutos</strong>, por lo que te recomendamos llegar puntual 
                para abordar con calma y disfrutar el trayecto.
                Habrá personal de apoyo para organizar los grupos y facilitar el abordaje.
            </p>
            <p>
                Si prefieres no usar trajinera, también puedes caminar entre 
                <strong>6 y 10 minutos</strong> desde el Embarcadero Nuevo Nativitas hasta la 
                entrada de Hacienda Zacapa. 🚶🏻‍♂️
                <a href="https://vimeo.com/804675785" target="_blank" rel="noopener noreferrer">
                    Ver video de la ruta
                </a>
            </p>
            <p>
                Debido al tráfico habitual en la CDMX (especialmente los fines de semana), 
                te recomendamos salir con tiempo suficiente para evitar contratiempos. Ten en 
                cuenta que la zona del embarcadero suele estar muy concurrida, por lo que vale 
                la pena considerar unos minutos extra para estacionar o ubicar tu trajinera con calma.
            </p>
            <p>
                📍 
                <a href="https://maps.app.goo.gl/1jiETw4ztP3e1MdJ7" target="_blank" rel="noopener noreferrer">Hacienda Zacapa</a>
            </p>
        `
    },
    {
        sImg: sImg2,
        flower: flowerShape2,
        title: 'Hospedaje recomendado',
        description: `
            <p>
                Te recomendamos hospedarte en el 
                <strong>City Express Plus by Marriott Periférico Sur Tlalpan</strong>, 
                con el que tenemos convenio. Te sugerimos reservar con anticipación, 
                ya que las habitaciones están sujetas a disponibilidad.
            </p>

            <p>
                <strong>Promoción válida</strong> con desayuno incluido (únicamente en esta sede).
            </p>

            <p>
                Precios exclusivos para reservaciones realizadas en recepción del hotel o al 
                teléfono <a href="tel:5554836700">55 5483 6700</a>, extensión 2, 
                indicando el código: <strong>“Daniela y Mario”</strong>.
            </p>

            <p>
                <em>Válido para reservaciones realizadas del 23 de junio de 2025 al 07 de diciembre de 2025</em> 
                con estancias efectivas de hospedaje del <strong>04 al 08 de diciembre de 2025</strong>.
            </p>

            <ul>
                <li><strong>Estacionamiento:</strong> $60 por noche.</li>
                <li><strong>Persona adicional en habitación:</strong> $358.50 (impuestos incluidos).</li>
            </ul>
        `,
        order1: 'order-lg-2 order-1',
        order2: 'order-lg-1 order-2',
    },
]


const StorySection = (props) => {
    return (
        <section className="wpo-story-section-s2 section-padding pt-3" id="story">
            <div className="container">
                <SectionTitle subTitle={'Tips & Recomendaciones'} MainTitle={''} s2Class={'mb-0'} />
                <div className="wpo-story-wrap">
                    {
                        Storys.map((story, st) => (
                            <div className="wpo-story-item" key={st}>
                                <div className="row">
                                    <div className={`col col-lg-6 col-12 ${story.order1}`}>
                                        <div className="wpo-story-img">
                                            <img src={story.sImg} alt="" />
                                            {story.sImg2 && <img src={story.sImg2} alt="" />}
                                        </div>
                                    </div>
                                    <div className={`col col-lg-6 col-12 ${story.order2}`}>
                                        <JackInTheBox duration="1000" triggerOnce="true">
                                            <div className="wpo-story-content">
                                                <h2 className="text-center mt-5">{story.title}</h2>
                                                <div dangerouslySetInnerHTML={{ __html: story.description }} />
                                                <div className="flower">
                                                    <img src={story.flower} alt="" />
                                                </div>
                                            </div>
                                        </JackInTheBox>
                                    </div>
                                </div>
                                <div className="ring-wrap">
                                    {
                                        Array.apply(null, { length: 10 }).map((e, i) => (
                                            <div className="ring" key={i}><img src={ring} alt="" /></div>
                                        ))
                                    }
                                </div>
                            </div>
                        ))

                    }

                </div>
            </div>
            <div className="flower-shape-1">
                <img src={shape1} alt="" />
            </div>
            <div className="flower-shape-2">
                <img src={shape2} alt="" />
            </div>
            <div className="flower-shape-3">
                <img src={shape3} alt="" />
            </div>
            <div className="flower-shape-4">
                <img src={shape4} alt="" />
            </div>
        </section>
    )
}

export default StorySection;